<template>
  <v-container class="mt-4 px-5" fluid>
    <v-card class="shadowCard">
      <v-card-title primary-title class="text-subtitle-1">
        Bienvenida 2026
        <v-spacer></v-spacer>
        <v-btn
          color="blue-grey"
          class="white--text"
          small
          tile
          :href="imagen"
          :download="nombreDescarga"
          target="_blank"
        >
          Descargar
          <v-icon right dark>mdi-cloud-download</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text class="black--text">

        <v-row v-if="puedeElegirEscuela">
          <v-col cols="12" lg="4" md="6">
            <label>Elige escuela</label>
            <v-radio-group v-model="escuela" row>
              <v-radio label="INBI" :value="1"></v-radio>
              <v-radio label="FAST" :value="2"></v-radio>
            </v-radio-group>
          </v-col>
        </v-row>

        <v-row justify="center" dense>
          <v-col cols="12" md="8" lg="6">
            <v-img :src="imagen" contain :alt="escuela == 2 ? 'Bienvenida FAST 2026' : 'Bienvenida INBI 2026'" />
          </v-col>
        </v-row>

      </v-card-text>
    </v-card>
  </v-container>
</template>
<script>
  import { mapGetters } from 'vuex'
  import imagenFast from '@/assets/docs2026/bienvenida-fast-2026.jpg'
  import imagenInbi from '@/assets/docs2026/bienvenida-inbi-2026.jpg'

  const IDERPS_TODAS_ESCUELAS = [334, 1, 568, 1932]

  export default {
    data() {
      return {
        escuela: null,
      }
    },

    created() {
      this.escuela = this.getEscuela
    },

    computed: {
      ...mapGetters('login', ['getEscuela', 'getdatosUsuarioERPERP']),

      puedeElegirEscuela() {
        const usuario = this.getdatosUsuarioERPERP
        if (!usuario) return false
        return IDERPS_TODAS_ESCUELAS.includes(usuario.iderp)
      },

      imagen() {
        return this.escuela == 2 ? imagenFast : imagenInbi
      },

      nombreDescarga() {
        return this.escuela == 2 ? 'Bienvenida-FAST-2026.jpg' : 'Bienvenida-INBI-2026.jpg'
      },
    },
  }
</script>
